<template>
  <div class="tools-list">
    <icon size="18" class="active">touch_app</icon>
    <icon size="18">square_foot</icon>
    <icon size="18">edit</icon>
    <icon size="18">comment</icon>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.tools-list {
  display: flex;
  flex-direction: row;
  align-items: center;

  i {
    padding: 10px;
    margin-left: 5px;
    border-radius: 50%;
    transition: 0.3s all ease-in-out;

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      background: var(--color-secondary-light);
      cursor: pointer;
    }

    &:active {
      transform: scale(0.9);
    }

    &.active {
      background: var(--color-primary-light);
      color: var(--color-primary);
    }
  }
}
</style>
